import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAccountTransactionSummary as getAccountTransactionSummaryApi } from '../../helpers/bff_helper';

const namespace = 'wallet-summary';

export const getWalletSummary = createAsyncThunk(
  `${namespace}/getWalletSummary`,
  async (params) => {
    try {
      const response = await getAccountTransactionSummaryApi(params);
      return response;
    } catch (error) {
      return { error: true, message: error };
    }
  }
);
